import { cn } from "@/lib/utils";

/**
 * The horizontal Waves logo (/Logo_liggend.png). The PNG carries a lot of
 * whitespace around the artwork (~34% above/below, ~7% left/right), so it is
 * cropped to the artwork's bounding box via overflow. Size it with a height
 * class (e.g. `h-8`); the width follows from the aspect ratio.
 */
export function WavesLogo({ className }: { className?: string }) {
  return (
    <span className={cn("relative block aspect-[6521/1157] shrink-0 overflow-hidden", className)}>
      <img
        src="/Logo_liggend.png"
        alt="Waves"
        className="absolute left-[-7.94%] top-[-106.66%] block h-auto w-[115.89%] max-w-none"
      />
    </span>
  );
}
